namespace $.$$ {
	
	$mol_style_define( $mol_hint, {
		
		color: $mol_theme.shade,
		
		flex: {
			shrink: 1,
		},
		
		align: {
			items: 'flex-start',
		},
		
		Icon: {
			color: $mol_theme.control,
		},
		
	} )

}
